import React from "react";
import type { TabContentPanelProps } from "../types";

const TabContentPanel = ({ tabs, activeKey }: TabContentPanelProps) => {
  const activeTab = tabs?.find(({ props: { tabKey } }) => activeKey === tabKey);

  return <>{activeTab}</>;
};

export default TabContentPanel;
